"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Carousel } from "@nxt-costco-com/forge-components";
import { SpaceMd, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { AdSetTitle } from "../../AdSet/AdSetTitle.js";
import { MIN_CATEGORY_TILES, ITEMS_PER_SLIDE_TABLET, ITEMS_PER_SLIDE_MOBILE, ITEMS_PER_SLIDE_DESKTOP } from "../constants.js";
import { AdSetContainerStyles, adobeCategoryContainerStyles } from "../styles.js";
import { normalizeAdobeCategoryData } from "../utils.js";
import { CategoryTileUI } from "../../CategoryTile/CategoryTileUI/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useAdobe } from "../../../../hooks/useAdobe/index.js";
const COMPONENT_NAME = "CategoryAdSet";
const CategoryAdSet = ({
  entry,
  entryId,
  titleProps,
  keyword,
  sx = {}
}) => {
  const { adobeCategoryResponse } = useAdobe(entry, keyword);
  const normalizedData = normalizeAdobeCategoryData(adobeCategoryResponse);
  if (!normalizedData || normalizedData.length < MIN_CATEGORY_TILES) {
    return null;
  }
  const adSetContainerStyles = AdSetContainerStyles();
  if ((entry == null ? void 0 : entry.ad_set_style) === "rotating") {
    return /* @__PURE__ */ jsxs(
      CostcoBox,
      {
        sx: {
          ...adSetContainerStyles,
          maxWidth: "100vw",
          ...sx
        },
        children: [
          titleProps && /* @__PURE__ */ jsx(AdSetTitle, { ...titleProps }),
          /* @__PURE__ */ jsx(
            Carousel,
            {
              containerSx: {
                margin: `0 ${SpaceXs}`,
                padding: 0
              },
              items: normalizedData == null ? void 0 : normalizedData.map((category, id) => {
                const index = id.toString();
                return category && /* @__PURE__ */ jsx(
                  CategoryTileUI,
                  {
                    background: false,
                    categoryData: category,
                    dataTestId: `${COMPONENT_NAME}-${entryId}-${index}`,
                    foreground: true,
                    hasCategoryTitle: true,
                    isLoading: false,
                    variant: "stacked"
                  },
                  `adobeCategoryTile_${index}`
                );
              }),
              itemsPerSlide: {
                desktop: ITEMS_PER_SLIDE_DESKTOP,
                mobile: ITEMS_PER_SLIDE_MOBILE,
                tablet: ITEMS_PER_SLIDE_TABLET
              },
              slideContainerSx: {
                ".slider-list": {
                  margin: "auto"
                }
              },
              labelledBy: titleProps == null ? void 0 : titleProps.titleId,
              randomizeItems: entry.rotating_options.randomize_items,
              slideGap: SpaceMd,
              wrapAround: false
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(CostcoBox, { sx: { ...adSetContainerStyles }, children: [
    titleProps && /* @__PURE__ */ jsx(AdSetTitle, { ...titleProps }),
    /* @__PURE__ */ jsx(CostcoBox, { sx: adobeCategoryContainerStyles, children: normalizedData == null ? void 0 : normalizedData.map((category, id) => {
      const index = id.toString();
      return category && /* @__PURE__ */ jsx(
        CategoryTileUI,
        {
          background: false,
          categoryData: category,
          dataTestId: `${COMPONENT_NAME}-${entryId}-${index}`,
          foreground: true,
          hasCategoryTitle: true,
          isLoading: false,
          variant: "stacked"
        },
        `adobeCategoryTile_${index}`
      );
    }) })
  ] });
};
export {
  CategoryAdSet
};
